"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerList = PlayerList;
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const context_1 = require("~/auth/context");
const networking_1 = require("~/networking");
const plugins_1 = require("~/plugins");
const models_1 = require("@creature-chess/models");
const models_2 = require("@creature-chess/models");
const playerListItem_1 = require("./playerListItem");
const statusPlayerListItem_1 = require("./statusPlayerListItem");
const react_jss_1 = require("react-jss");
// todo move this
const getOrdinalSuffix = (i) => {
    const j = i % 10;
    const k = i % 100;
    if (j === 1 && k !== 11) {
        return i + "st";
    }
    if (j === 2 && k !== 12) {
        return i + "nd";
    }
    if (j === 3 && k !== 13) {
        return i + "rd";
    }
    return i + "th";
};
const getOpponentName = (battle, players) => {
    var _a;
    if (!battle) {
        return "";
    }
    return ((_a = players.find((p) => p.id === battle.opponentId)) === null || _a === void 0 ? void 0 : _a.name) || "";
};
const useStyles = (0, react_jss_1.createUseStyles)({
    list: {
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        padding: "10px",
        background: "#1d1d1d",
        minHeight: "100%",
        boxSizing: "border-box",
    },
});
function PlayerList() {
    const styles = useStyles();
    const gameActions = (0, networking_1.useGameActions)();
    const accountId = (0, context_1.useAccountId)();
    const players = (0, react_redux_1.useSelector)((state) => state.game.players);
    const opponentId = (0, react_redux_1.useSelector)((state) => state.game.localPlayer.opponentId);
    const showReadyIndicators = (0, react_redux_1.useSelector)((state) => state.game.roundInfo.phase === models_1.GamePhase.PREPARING);
    const currentlySpectatingId = (0, react_redux_1.useSelector)((state) => state.game.spectating.id);
    return (React.createElement("div", { className: styles.list }, players.map((p, index) => {
        const opponentName = getOpponentName(p.battle, players);
        const position = index + 1;
        const inner = p.status === models_2.PlayerStatus.QUIT ? (React.createElement(statusPlayerListItem_1.StatusPlayerListItem, { name: p.name, opponentName: opponentName, battle: p.battle, status: "Quit" })) : p.status === models_2.PlayerStatus.DEAD ? (React.createElement(statusPlayerListItem_1.StatusPlayerListItem, { name: p.name, opponentName: opponentName, battle: p.battle, status: "Dead", subtitle: `${getOrdinalSuffix(position)} place` })) : (React.createElement(playerListItem_1.PlayerListItem, { index: index, player: p, isOpponent: p.id === opponentId, isLocal: p.id === accountId, onSpectateClick: () => gameActions.spectate(currentlySpectatingId === p.id ? null : p.id), opponentName: opponentName, currentlySpectating: currentlySpectatingId === p.id, showReadyIndicator: showReadyIndicators }));
        return (React.createElement(plugins_1.Region, { key: p.id, cls: "player-list-row", id: `player-list.row.${p.id}`, ctx: { playerId: p.id, position } }, inner));
    })));
}
